// extracted by mini-css-extract-plugin
module.exports = {"SearchBox":"DrawingMap_SearchBox__AdmdG","DeleteShapeButton":"DrawingMap_DeleteShapeButton__2DE3l"};